module.exports = __webpack_public_path__ + "static/ffuncar-free-delivery-532ffe1b95f2a58f63d1fd34fc58db5f.webp";